import React, { useState, useEffect } from 'react';
import appUrl from "../../../../constants/appUrl";

const UserProcess = () => {
    const [processList, setProcessList] = useState([]);

    const GetAllProcess = async () => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/Process/GetAllProcess`);
            const data = await response.json();
            setProcessList(data);
        } catch (error) {
            console.error('Error fetching FAQs:', error);
        }
    };

    useEffect(() => {
        GetAllProcess();
    }, []);

    return (
        <div>
            {processList.map((item) => (
                <div key={item.productID}>
                    <div className='card'>
                        <div className='heading-custom'>
                            <div className='grid'>
                                <div className='md:col-4'>
                                    <h5>{item.productName}</h5>
                                </div>
                                <div className='md:col-4'>
                                    <h5>{item.productChannel}</h5> 
                                </div>
                                <div className='md:col-4'>
                                    <h5>{item.createdDate}</h5> 
                                </div>
                            </div>
                        </div>
                        <div className='grid'>
                            <div className='md:col-12'>
                                <ul>
                                    {item.processModels.map((process) => (
                                        <li key={process.processId}>{process.description}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UserProcess;
